import Vue from 'vue'
import VueRouter from 'vue-router'

// Normal views
import ClientView from '@/views/flow/ClientView';
import ManagerView from '@/views/flow/ManagerView';
import DevView from '@/views/flow/DevView';

const routes = [
  {
    path: '/dev',
    name: 'Dev',
    component: DevView,
  },

  {
    path: '/manager',
    name: 'Manager',
    component: ManagerView,
    children: [
      {
        path: 'login',
        meta: {
          mainPage: 'manager',
          childPage: 'intro',
        },
      },
      {
        path: 'control-panel',
        meta: {
          mainPage: 'manager',
          childPage: 'control-panel',
        },
      },
      {
        path: 'section',
        meta: {
          mainPage: 'manager',
          childPage: 'section',
        },
      },
      {
        path: 'results',
        meta: {
          mainPage: 'manager',
          childPage: 'results',
        },
      },
    ],
  },

  {
    path: '*',
    name: 'Client',
    component: ClientView,
    children: [
      {
        path: 'intro',
        meta: {
          mainPage: 'client',
          childPage: 'intro',
        },
      },
      {
        path: 'register',
        meta: {
          mainPage: 'client',
          childPage: 'register',
        },
      },
      {
        path: 'vote',
        meta: {
          mainPage: 'client',
          childPage: 'vote',
        },
      },
    ],
  },
];

Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
